import { shouldDisplayBonusInelligibleBadge } from "../../../../helpers";
export function getNestedSelectionListStyles(playerBonus, selection) {
    return {
        marginTop: shouldDisplayBonusInelligibleBadge(playerBonus, selection) ? undefined : "4px",
        marginBottom: "12px",
    };
}
//# sourceMappingURL=getNestedSelectionListStyles.js.map